import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ApiError } from "@youm-front/api/domain";
import { ApiActions } from "../actions";

@Injectable()
export class ApiFacade {
  constructor(private readonly _store: Store<object>) {}

  error(error: ApiError) {
    this._store.dispatch(ApiActions.apiError({ error }));
  }
}
